// Hebrew phrases

export default {
  // cSpell:ignore panel side
  com_sidepanel_select_assistant: 'בחר סייען',
  com_sidepanel_assistant_builder: 'בניית סייען',
  com_sidepanel_attach_files: 'צרף קבצים',
  com_sidepanel_conversation_tags: 'סימניות',
  com_assistants_knowledge: 'ידע',
  com_assistants_knowledge_info:
    'אם אתה מעלה קבצים תחת ידע, שיחות עם ה-סייען שלך עשויות לכלול תוכן מהקובץ.',
  com_assistants_knowledge_disabled:
    'יש ליצור סייען, ויש להפעיל ולשמור את מתורגמן קוד או אחזור לפני העלאת קבצים כ-ידע.',
  com_assistants_append_date: 'הוסף תאריך ושעה נוכחיים',
  com_assistants_append_date_tooltip:
    'כשמופעל, תאריך ושעה נוכחיים של הלקוח יוספים להוראות מערכת הסייען.',
  com_assistants_code_interpreter: 'מתורגמן קוד',
  com_assistants_code_interpreter_files: 'הקבצים הבאים זמינים רק עבור מתורגמן קוד:',
  com_assistants_retrieval: 'אחזור',
  com_assistants_tools_section: 'פעולות, כלים',
  com_assistants_add_tools: 'הוסף כלים',
  com_assistants_add_actions: 'הוסף פעולות',
  com_assistants_name_placeholder: 'אופציונלי: שם הסייען',
  com_assistants_instructions_placeholder: 'הוראות המערכת שהסייען משתמש בהן',
  com_assistants_description_placeholder: 'אופציונלי: תאר את ה-סייען שלך כאן',
  com_assistants_actions_disabled: 'עליך ליצור סייען לפני הוספת פעולות.',
  com_assistants_update_success: 'עודכן בהצלחה',
  com_assistants_update_error: 'אירעה שגיאה בעדכון הסייען שלך.',
  com_assistants_create_success: 'נוצר בהצלחה',
  com_assistants_create_error: 'אירעה שגיאה ביצירת הסייען שלך.',
  com_ui_attach_error_type: 'סוג קובץ לא נתמך עבור נקודת קצה:',
  com_ui_attach_error_size: 'חרגת ממגבלת גודל הקובץ עבור נקודת הקצה:',
  com_ui_attach_error: 'לא ניתן לצרף קובץ. צור או בחר שיחה, או נסה לרענן את הדף.',
  com_ui_examples: 'דוגמאות',
  com_ui_new_chat: 'שיחה חדשה',
  com_ui_happy_birthday: 'זה יום ההולדת הראשון שלי!',
  com_ui_example_quantum_computing: 'הסבר מחשוב קוונטי במונחים פשוטים',
  com_ui_example_10_year_old_b_day: 'יש לך רעיונות יצירתיים ליום הולדת של ילד בן 10?',
  com_ui_example_http_in_js: 'כיצד אוכל לבצע בקשת HTTP ב-Javascript?',
  com_ui_capabilities: 'יכולות',
  com_ui_capability_remember: 'זוכר את מה שהמשתמש אמר קודם בשיחה',
  com_ui_capability_correction: 'מאפשר למשתמש לספק תיקוני המשך',
  com_ui_capability_decline_requests: 'אומן לדחות בקשות בלתי הולמות',
  com_ui_limitations: 'הגבלות',
  com_ui_limitation_incorrect_info: 'עשוי מדי פעם ליצור מידע שגוי',
  com_ui_limitation_harmful_biased: 'עלול לייצר מדי פעם הוראות מזיקות או תוכן מוטה',
  com_ui_limitation_limited_2021: 'ידע מוגבל על העולם והאירועים אחרי 2021',
  com_ui_experimental: 'מאפיינים ניסיוניים',
  com_ui_name: 'שם',
  com_ui_instructions: 'הוראות',
  com_ui_description: 'תיאור',
  com_ui_error: 'שגיאה',
  com_ui_select: 'בחר',
  com_ui_input: 'קלט',
  com_ui_close: 'סגור',
  com_ui_model: 'דגם',
  com_ui_select_model: 'בחר דגם',
  com_ui_use_prompt: 'השתמש בהודעת',
  com_ui_prev: 'הקודם',
  com_ui_next: 'הבא',
  com_ui_stop: 'עצור',
  com_ui_upload_files: 'העלה קבצים',
  com_ui_prompt_templates: 'תבניות בקשה',
  com_ui_hide_prompt_templates: 'הסתר תבניות הנחיות',
  com_ui_showing: 'מציג',
  com_ui_of: 'של',
  com_ui_entries: 'ערכים',
  com_ui_pay_per_call: 'כל שיחות הבינה המלאכותית במקום אחד. שלם לפי שיחה ולא לחודש',
  com_ui_new_footer: 'כל שיחות הבינה המלאכותית במקום אחד.',
  com_ui_enter: 'Enter',
  com_ui_submit: 'שלח',
  com_ui_upload_success: 'קובץ שהועלה בהצלחה',
  com_ui_upload_error: 'אירעה שגיאה בהעלאת הקובץ שלך',
  com_ui_cancel: 'בטל',
  com_ui_save: 'שמור',
  com_ui_save_submit: 'שמור ושלח',
  com_user_message: 'אתה',
  com_ui_copy_to_clipboard: 'העתק ללוח',
  com_ui_copied_to_clipboard: 'הועתק ללוח',
  com_ui_regenerate: 'לחדש',
  com_ui_continue: 'המשך',
  com_ui_edit: 'ערוך',
  com_ui_success: 'הצלחה',
  com_ui_all: 'הכל',
  com_ui_clear: 'נקה',
  com_ui_revoke: 'בטל',
  com_ui_revoke_info: 'בטל את כל האישורים שסופקו על ידי המשתמש',
  com_ui_import_conversation: 'יבוא',
  com_ui_import_conversation_info: 'ייבא שיחות מקובץ JSON',
  com_ui_import_conversation_success: 'השיחות יובאו בהצלחה',
  com_ui_import_conversation_error: 'אירעה שגיאה בעת ייבוא השיחות שלך',
  com_ui_confirm_action: 'אשר פעולה',
  com_ui_chats: 'צאטים',
  com_ui_assistant: 'סייען',
  com_ui_delete: 'מחק',
  com_ui_create: 'צור',
  com_ui_share: 'שתף',
  com_ui_copy_link: 'העתק קישור',
  com_ui_update_link: 'עדכן קישור',
  com_ui_create_link: 'צור קישור',
  com_ui_share_link_to_chat: 'שתף קישור בצ\'אט',
  com_ui_share_error: 'אירעה שגיאה בעת שיתוף קישור הצ\'אט',
  com_ui_share_retrieve_error: 'אירעה שגיאה בעת מחיקת הקישור המשותף.',
  com_ui_share_delete_error: 'אירעה שגיאה בעת מחיקת הקישור המשותף.',
  com_ui_share_create_message: 'שמך וכל הודעה שתוסיף לאחר השיתוף יישארו פרטיים.',
  com_ui_share_created_message:
    'A shared link to your chat has been created. Manage previously shared chats at any time via Settings.',
  com_ui_share_update_message:
    'Your name, custom instructions, and any messages you add after sharing stay private.',
  com_ui_share_updated_message:
    'A shared link to your chat has been updated. Manage previously shared chats at any time via Settings.',
  com_ui_shared_link_not_found: 'Shared link not found',
  com_ui_delete_conversation: 'למחוק את השיחה (צאט)?',
  com_ui_delete_confirm: 'זה ימחק',
  com_ui_delete_assistant_confirm:
    'האם אתה בטוח שאתה רוצה למחוק את הסייען הזה? אי אפשר לבטל את זה.',
  com_ui_rename: 'שם מחדש',
  com_ui_archive: 'ארכיון',
  com_ui_archive_error: 'אירעה שגיאה בארכיון השיחה',
  com_ui_unarchive: 'לארכיון',
  com_ui_unarchive_error: 'אירעה שגיאה בארכיון השיחה',
  com_ui_more_options: 'עוד',
  _ui_preview: 'תצוגה מקדימה',
  com_ui_upload: 'העלה',
  com_ui_connect: 'התחבר',
  com_ui_bookmarks: 'סימניות',
  com_ui_bookmarks_rebuild: 'בנה מחדש',
  com_ui_bookmarks_new: 'סימניה חדשה',
  com_ui_bookmark_delete_confirm: 'האם אתה בטוח שברצונך למחוק את הסימניה הזו?',
  com_ui_bookmarks_title: 'כותרת',
  com_ui_bookmarks_count: 'ספירה',
  com_ui_bookmarks_description: 'תיאור',
  com_ui_bookmarks_create_success: 'הסימניה נוצרה בהצלחה',
  com_ui_bookmarks_update_success: 'הסימניה עודכנה בהצלחה',
  com_ui_bookmarks_delete_success: 'הסימניה נמחקה בהצלחה',
  com_ui_bookmarks_create_error: 'אירעה שגיאה בעת יצירת הסימניה',
  com_ui_bookmarks_update_error: 'אירעה שגיאה בעת עדכון הסימניה',
  com_ui_bookmarks_delete_error: 'אירעה שגיאה בעת מחיקת הסימניה',
  com_ui_bookmarks_add_to_conversation: 'הוסף לשיחה הנוכחית',
  com_ui_accept: 'אני מקבל',
  com_ui_decline: 'אני לא מקבל',
  com_ui_terms_and_conditions: 'תנאים והגבלות',
  com_ui_no_terms_content: 'אין תוכן תנאים והגבלות להצגה',
  com_auth_error_login: 'לא ניתן להתחבר עם המידע שסופק. אנא בדוק את האישורים שלך ונסה שוב.',
  com_auth_error_login_rl: 'יותר מדי ניסיונות כניסה בזמן קצר. בבקשה נסה שוב מאוחר יותר.',
  com_auth_error_login_ban: 'החשבון שלך נחסם באופן זמני עקב הפרות של השירות שלנו.',
  com_auth_error_login_server: 'הייתה שגיאת שרת פנימית. אנא המתן מספר רגעים ונסה שוב.',
  com_auth_no_account: 'אין לך חשבון?',
  com_auth_sign_up: 'הירשם',
  com_auth_sign_in: 'כניסה',
  com_auth_google_login: 'המשך עם Google',
  com_auth_facebook_login: 'המשך עם פייסבוק',
  com_auth_github_login: 'המשך עם Github',
  com_auth_discord_login: 'המשך עם Discord',
  com_auth_email: 'אימייל (דוא"ל)',
  com_auth_email_required: 'נדרש דוא"ל',
  com_auth_email_min_length: 'אימייל (דוא"ל) חייב להיות בן 6 תווים לפחות',
  com_auth_email_max_length: 'אימייל (דוא"ל) לא יכול להיות ארוך מ-120 תווים',
  com_auth_email_pattern: 'עליך להזין כתובת אימייל (דוא"ל) חוקית',
  com_auth_email_address: 'כתובת דואר אלקטרוני',
  com_auth_password: 'סיסמה',
  com_auth_password_required: 'נדרשת סיסמה',
  com_auth_password_min_length: 'הסיסמה חייבת להיות בת 8 תווים לפחות',
  com_auth_password_max_length: 'הסיסמה חייבת להיות פחות מ-128 תווים',
  com_auth_password_forgot: 'שכחת את הסיסמה?',
  com_auth_password_confirm: 'אשר סיסמה',
  com_auth_password_not_match: 'הסיסמאות אינן תואמות',
  com_auth_continue: 'המשך',
  com_auth_create_account: 'צור את החשבון שלך',
  com_auth_error_create: 'אירעה שגיאה בניסיון לרשום את החשבון שלך. בבקשה נסה שוב.',
  com_auth_full_name: 'שם מלא',
  com_auth_name_required: 'נדרש שם',
  com_auth_name_min_length: 'השם חייב להיות לפחות 3 תווים',
  com_auth_name_max_length: 'השם חייב להיות פחות מ-80 תווים',
  com_auth_username: 'שם משתמש (אופציונלי)',
  com_auth_username_required: 'נדרש שם משתמש',
  com_auth_username_min_length: 'שם משתמש חייב להיות לפחות 2 תווים',
  com_auth_username_max_length: 'שם המשתמש חייב להיות פחות מ-20 תווים',
  com_auth_already_have_account: 'כבר יש לך חשבון?',
  com_auth_login: 'התחבר',
  com_auth_reset_password: 'אפס את הסיסמה שלך',
  com_auth_click: 'קליק',
  com_auth_here: 'כאן',
  com_auth_to_reset_your_password: 'כדי לאפס את הסיסמה שלך.',
  com_auth_reset_password_link_sent: 'אימייל (דוא"ל) נשלח',
  com_auth_reset_password_email_sent: 'נשלח אליך הודעת דוא"ל עם הנחיות נוספות לאיפוס הסיסמה שלך.',
  com_auth_error_reset_password:
    'הייתה בעיה באיפוס הסיסמה שלך. לא נמצא משתמש עם כתובת האימייל (דוא"ל) שסופקה. בבקשה נסה שוב.',
  com_auth_reset_password_success: 'איפוס סיסמה הצליח',
  com_auth_login_with_new_password: 'עכשיו אתה יכול להתחבר עם הסיסמה החדשה שלך.',
  com_auth_error_invalid_reset_token: 'אסימון איפוס הסיסמה הזה אינו תקף עוד.',
  com_auth_click_here: 'לחץ כאן',
  com_auth_to_try_again: 'כדי לנסות שוב.',
  com_auth_submit_registration: 'שלח רישום',
  com_auth_welcome_back: 'ברוכים הבאים',
  com_auth_back_to_login: 'חזרה לכניסה',
  com_endpoint_open_menu: 'תפריט פתח',
  com_endpoint_bing_enable_sydney: 'אפשר את סידני',
  com_endpoint_bing_to_enable_sydney: 'כדי לאפשר את סידני',
  com_endpoint_bing_jailbreak: 'Jailbreak',
  com_endpoint_bing_context_placeholder:
    'בינג יכול להשתמש בעד 7,000 אסימונים עבור \'הקשר\', שאליהם הוא יכול להתייחס לשיחה. המגבלה הספציפית אינה ידועה אך עשויה להיתקל בשגיאות העולות על 7,000 אסימונים',
  com_endpoint_bing_system_message_placeholder:
    'אזהרה: שימוש לרעה בתכונה זו יכול לגרום לך לאסור להשתמש ב-Bing! לחץ על \'הודעת מערכת\' לקבלת הוראות מלאות והודעת ברירת המחדל אם הושמטה, שהיא הקביעה המוגדרת מראש של \'Sydney\' שנחשבת בטוחה.',
  com_endpoint_system_message: 'הודעת מערכת',
  com_endpoint_message: 'הודעה',
  com_endpoint_message_not_appendable: 'ערוך את ההודעה שלך או צור מחדש.',
  com_endpoint_default_blank: 'ברירת מחדל: ריק',
  com_endpoint_default_false: 'ברירת מחדל: false',
  com_endpoint_default_creative: 'ברירת מחדל: יצירתי',
  com_endpoint_default_empty: 'ברירת מחדל: ריקה',
  com_endpoint_default_with_num: 'ברירת מחדל: {0}',
  com_endpoint_context: 'הקשר',
  com_endpoint_tone_style: 'סגנון טון',
  com_endpoint_token_count: 'ספירת אסימונים',
  com_endpoint_output: 'פלט',
  com_endpoint_google_temp:
    'ערכים גבוהים יותר = יותר אקראיים, בעוד שערכים נמוכים יותר = יותר ממוקד ודטרמיניסטי. אנו ממליצים לשנות את זה או את Top P אבל לא את שניהם.',
  com_endpoint_google_topp:
    'Top-p משנה את האופן שבו המודל בוחר אסימונים לפלט. אסימונים נבחרים מרוב K (ראה פרמטר topK) ככל הנראה לפחות עד ה-sum של ההסתברויות שלהם שווה לערך ה-p העליון.',
  com_endpoint_google_topk:
    'Top-k משנה את האופן שבו המודל בוחר אסימונים לפלט. Top-k של 1 פירושו שהאסימון שנבחר הוא הסביר ביותר מבין כל האסימונים באוצר המילים של הדגם (נקרא גם פענוח חמדן), בעוד ש-top-k של 3 פירושו שהאסימון הבא נבחר מבין 3 הכי הרבה. אסימונים סבירים (באמצעות טמפרטורה).',
  com_endpoint_google_maxoutputtokens:
    ' המספר המרבי של אסימונים שניתן להפיק בתגובה. ציין ערך נמוך יותר עבור תגובות קצרות יותר וערך גבוה יותר עבור תגובות ארוכות יותר.',
  com_endpoint_google_custom_name_placeholder: 'הגדר שם מותאם אישית עבור Google',
  com_endpoint_prompt_prefix_placeholder: 'הגדר הוראות מותאמות אישית או הקשר. התעלמו אם ריק.',
  com_endpoint_instructions_assistants_placeholder:
    'עובר את הוראות הסייען. זה שימושי לשינוי ההתנהגות על בסיס ריצה.',
  com_endpoint_prompt_prefix_assistants_placeholder:
    'הגדר הוראות נוספות או הקשר על גבי ההנחיות הראשיות של ה-סייען. התעלמו אם ריק.',
  com_endpoint_custom_name: 'שם מותאם אישית',
  com_endpoint_prompt_prefix: 'הוראות מותאמות אישית',
  com_endpoint_prompt_prefix_assistants: 'הוראות נוספות',
  com_endpoint_instructions_assistants: 'עקוף הוראות',
  com_endpoint_temperature: 'טמפרטורה',
  com_endpoint_default: 'default',
  com_endpoint_top_p: 'Top P',
  com_endpoint_top_k: 'Top K',
  com_endpoint_max_output_tokens: 'אסימוני פלט מרבי',
  com_endpoint_openai_temp:
    'ערכים גבוהים יותר = יותר אקראיים, בעוד שערכים נמוכים יותר = יותר ממוקד ודטרמיניסטי. אנו ממליצים לשנות את זה או את Top P אבל לא את שניהם.',
  com_endpoint_openai_max:
    'האסימונים המקסימליים להפיק. האורך הכולל של אסימוני קלט ואסימונים שנוצרו מוגבל על ידי אורך ההקשר של המודל.',
  com_endpoint_openai_topp:
    'חלופה לדגימה עם טמפרטורה, הנקראת דגימת גרעין, שבה המודל מחשיב את תוצאות האסימונים עם מסת ההסתברות top_p. אז 0.1 אומר שרק האסימונים המהווים את מסת ההסתברות העליונה של 10% נחשבים. אנו ממליצים לשנות את זה או את הטמפרטורה אבל לא את שניהם.',
  com_endpoint_openai_freq:
    'מספר בין -2.0 ל-2.0. ערכים חיוביים מענישים אסימונים חדשים בהתבסס על התדירות הקיימת שלהם בטקסט עד כה, ומקטינים את הסבירות של המודל לחזור על אותה שורה מילה במילה.',
  com_endpoint_openai_pres:
    'מספר בין -2.0 ל-2.0. ערכים חיוביים מענישים אסימונים חדשים על סמך האם הם מופיעים בטקסט עד כה, ומגדילים את הסבירות של המודל לדבר על נושאים חדשים.',
  com_endpoint_openai_resend:
    'שלח שוב את כל התמונות שצורפו בעבר. הערה: זה יכול להגדיל משמעותית את עלות האסימונים ואתה עלול להיתקל בשגיאות עם קבצים מצורפים רבים של תמונות.',
  com_endpoint_openai_detail:
    'ההחלטה לבקשות חזון. "נמוך" זול ומהיר יותר, "גבוה" מפורט ויקר יותר, ו"אוטומטי" יבחר אוטומטית בין השניים על סמך רזולוציית התמונה.',
  com_endpoint_openai_custom_name_placeholder: 'הגדר שם מותאם אישית עבור ChatGPT',
  com_endpoint_openai_prompt_prefix_placeholder:
    'הגדר הוראות מותאמות אישית לכלול בהודעת המערכת. ברירת מחדל: אין',
  com_endpoint_anthropic_temp:
    'נע בין 0 ל-1. השתמש בטמפ\' הקרובה יותר ל-0 עבור בחירה אנליטית / מרובה, וקרוב יותר ל-1 עבור משימות יצירתיות ויצירתיות. אנו ממליצים לשנות את זה או את Top P אבל לא את שניהם.',
  com_endpoint_anthropic_topp:
    'Top-p משנה את האופן שבו המודל בוחר אסימונים לפלט. אסימונים נבחרים מבין רוב K (ראה פרמטר topK) הסביר לפחות עד שסכום ההסתברויות שלהם שווה לערך העליון-p.',
  com_endpoint_anthropic_topk:
    'Top-k משנה את האופן שבו המודל בוחר אסימונים לפלט. Top-k של 1 פירושו שהאסימון שנבחר הוא הסביר ביותר מבין כל האסימונים באוצר המילים של הדגם (נקרא גם פענוח חמדן), בעוד ש-top-k של 3 פירושו שהאסימון הבא נבחר מבין 3 הכי הרבה. אסימונים סבירים (באמצעות טמפרטורה).',
  com_endpoint_anthropic_maxoutputtokens:
    'מספר האסימונים המרבי שניתן להפיק בתגובה. ציין ערך נמוך יותר עבור תגובות קצרות יותר וערך גבוה יותר עבור תגובות ארוכות יותר.',
  com_endpoint_anthropic_custom_name_placeholder: 'הגדר שם מותאם אישית עבור Anthropic',
  com_endpoint_frequency_penalty: 'עונש תדירות',
  com_endpoint_presence_penalty: 'עונש נוכחות',
  com_endpoint_plug_use_functions: 'השתמש בפונקציות',
  com_endpoint_plug_resend_images: 'שלח שוב תמונות',
  com_endpoint_plug_image_detail: 'פרטי תמונה',
  com_endpoint_plug_skip_completion: 'השלמת דילוג',
  com_endpoint_disabled_with_tools: 'מושבת עם כלים',
  com_endpoint_disabled_with_tools_placeholder: 'מושבת עם הכלים שנבחרו',
  com_endpoint_plug_set_custom_instructions_for_gpt_placeholder:
    'הגדר הוראות מותאמות אישית לכלול בהודעת המערכת. ברירת מחדל: אין',
  com_hedpoint_import: 'ייבוא',
  com_endpoint_set_custom_name: 'הגדר שם מותאם אישית, למקרה שתוכל למצוא את הקביעה המוגדרת מראש',
  com_endpoint_preset_delete_confirm: 'האם אתה בטוח שברצונך למחוק את הקביעה המוגדרת מראש הזו?',
  com_endpoint_preset_clear_all_confirm:
    'האם אתה בטוח שברצונך למחוק את כל הקביעות המוגדרות מראש שלך?',
  com_endpoint_preset_import: 'הגדרה מראש מיובאת!',
  com_endpoint_preset_import_error: 'אירעה שגיאה בייבוא הקביעה המוגדרת מראש שלך. בבקשה נסה שוב.',
  com_endpoint_preset_save_error: 'אירעה שגיאה בשמירת ההגדרה מראש שלך. בבקשה נסה שוב.',
  com_endpoint_preset_delete_error: 'אירעה שגיאה במחיקת הקביעה המוגדרת מראש שלך. בבקשה נסה שוב.',
  com_endpoint_preset_default_removed: 'איננו עוד ברירת המחדל המוגדרת מראש.',
  com_endpoint_preset_default_item: 'ברירת מחדל:',
  com_endpoint_preset_default_none: 'אין ברירת מחדל פעילה.',
  com_endpoint_preset_title: 'הגדרה מראש',
  com_ui_saved: 'שמור!',
  com_endpoint_preset_default: 'הוא כעת ברירת המחדל המוגדרת מראש.',
  com_endpoint_preset: 'preset',
  com_endpoint_presets: 'presets',
  com_endpoint_preset_selected: 'הגדרה מראש פעילה!',
  com_endpoint_preset_selected_title: 'פעיל!',
  com_endpoint_preset_name: 'שם מוגדר מראש',
  com_endpoint_new_topic: 'נושא חדש',
  com_endpoint: 'נקודת קצה',
  com_endpoint_hide: 'הסתר',
  com_endpoint_show: 'הצג',
  com_endpoint_examples: 'הגדרות קבועות מראש',
  com_endpoint_completion: 'השלמה',
  com_endpoint_agent: 'סוכן',
  com_endpoint_show_what_settings: 'הצג {0} הגדרות',
  com_endpoint_export: 'ייצוא',
  com_endpoint_assistant: 'סייען',
  com_endpoint_use_active_assistant: 'השתמש ב-סייען פעיל',
  com_endpoint_assistant_model: 'מודל סייען',
  com_endpoint_save_as_preset: 'שמור כ-preset',
  com_endpoint_presets_clear_warning:
    'האם אתה בטוח שאתה רוצה לנקות את כל הקביעות המוגדרות מראש? זה בלתי הפיך.',
  com_endpoint_not_implemented: 'לא מיושם',
  com_endpoint_no_presets: 'אין עדיין הגדרות מוגדרות מראש, השתמש בלחצן ההגדרות כדי ליצור אחת',
  com_endpoint_not_available: 'אין נקודת קצה זמינה',
  com_endpoint_view_options: 'אפשרויות תצוגה',
  com_endpoint_save_convo_as_preset: 'שמור שיחה כקביעה מראש',
  com_endpoint_my_preset: 'ההגדרה המוגדרת מראש שלי',
  com_endpoint_agent_model: 'מודל סוכן (מומלץ: GPT-3.5)',
  com_endpoint_completion_model: 'מודל השלמה (מומלץ: GPT-4)',
  com_endpoint_func_hover: 'אפשר שימוש בפלאגינים כפונקציות OpenAI',
  com_endpoint_skip_hover: 'אפשר דילוג על שלב ההשלמה, הסוקר את התשובה הסופית ואת השלבים שנוצרו',
  com_endpoint_config_key: 'הגדר מפתח API',
  com_endpoint_config_placeholder: 'הגדר את המפתח שלך בתפריט הכותרת לצאט.',
  com_endpoint_config_key_for: 'הגדר מפתח API עבור',
  com_endpoint_config_key_name: 'מפתח',
  com_endpoint_config_value: 'הזן ערך עבור',
  com_endpoint_config_key_name_placeholder: 'הגדר תחילה מפתח API',
  com_endpoint_config_key_encryption: 'המפתח שלך יוצפן וימחק ב',
  com_endpoint_config_key_expiry: 'זמן התפוגה',
  com_endpoint_config_click_here: 'לחץ כאן',
  com_endpoint_config_google_service_key: 'מפתח חשבון שירות Google',
  com_endpoint_config_google_cloud_platform: '(מ-Google Cloud Platform)',
  com_endpoint_config_google_api_key: 'מפתח Google API',
  com_endpoint_config_google_gemini_api: '(Gemini API)',
  com_endpoint_config_google_api_info:
    'כדי לקבל את מפתח ה-API של Generative Language (עבור תאומים),',
  com_endpoint_config_key_import_json_key: 'ייבוא מפתח JSON של חשבון שירות.',
  com_endpoint_config_key_import_json_key_success: 'מפתח JSON של חשבון שירות יובא בהצלחה',
  com_endpoint_config_key_import_json_key_invalid:
    'מפתח JSON חשבון שירות לא חוקי, האם ייבאת את הקובץ הנכון?',
  com_endpoint_config_key_get_edge_key: 'כדי לקבל את אסימון הגישה שלך ל-Bing, היכנס אל',
  com_endpoint_config_key_get_edge_key_dev_tool:
    'השתמש בכלי מפתחים או בתוסף בזמן שאתה מחובר לאתר כדי להעתיק את התוכן של קובץ ה-cookie _U. אם זה נכשל, עקוב אחר אלה',
  com_endpoint_config_key_edge_instructions: 'הוראות',
  com_endpoint_config_key_edge_full_key_string: 'כדי לספק את מחרוזות העוגיות המלאות.',
  com_endpoint_config_key_chatgpt: 'כדי לקבל את אסימון הגישה שלך ל-ChatGPT \'גרסה חינמית\', היכנס אל',
  com_endpoint_config_key_chatgpt_then_visit: 'ואז בקר',
  com_endpoint_config_key_chatgpt_copy_token: 'העתק אסימון גישה.',
  com_endpoint_config_key_google_need_to: 'אתה צריך',
  com_endpoint_config_key_google_vertex_ai: 'הפעל את Vertex AI',
  com_endpoint_config_key_google_vertex_api: 'API ב-Google Cloud, אז',
  com_endpoint_config_key_google_service_account: 'צור חשבון שירות',
  com_endpoint_config_key_google_vertex_api_role:
    'הקפד ללחוץ על \'צור והמשך\' כדי לתת לפחות את התפקיד \'Vertex AI User\'. לבסוף, צור מפתח JSON לייבא לכאן.',
  com_nav_welcome_message: 'איך אני יכול לעזור לך היום?',
  com_nav_auto_scroll: 'Auto-s גלול אל הכי חדש בפתיחה',
  com_nav_hide_panel: 'הסתר לוח הצד הימני ביותר',
  com_nav_modular_chat: 'אפשר החלפת נקודות קצה באמצע שיחה',
  com_nav_latex_parsing: 'ניתוח LaTeX בהודעות (עשוי להשפיע על הביצועים)',
  com_nav_profile_picture: 'תמונת פרופיל',
  com_nav_change_picture: 'שנה תמונה',
  com_nav_plugin_store: 'חנות פלאגין',
  com_nav_plugin_install: 'התקן',
  com_nav_plugin_uninstall: 'הסר התקנה',
  com_ui_add: 'הוסף',
  com_nav_tool_remove: 'הסר',
  com_nav_tool_dialog: 'כלי סייען',
  com_nav_tool_dialog_description: 'יש לשמור את האסיסטנט כדי להמשיך בבחירת הכלים.',
  com_show_agent_settings: 'הצג הגדרות סוכן',
  com_show_completion_settings: 'הצג הגדרות השלמה',
  com_hide_examples: 'הסתר דוגמאות',
  com_show_examples: 'הצג דוגמאות',
  com_nav_plugin_search: 'תוספי חיפוש',
  com_nav_tool_search: 'כלי חיפוש',
  com_nav_plugin_auth_error: 'אירעה שגיאה בניסיון לאמת את הפלאגין הזה. בבקשה נסה שוב.',
  com_nav_export_filename: 'שם קובץ',
  com_nav_export_filename_placeholder: 'הגדר את שם הקובץ',
  com_nav_export_type: 'סוג',
  com_nav_export_include_endpoint_options: 'כלול אפשרויות נקודת קצה',
  com_nav_enabled: 'מופעל',
  com_nav_not_supported: 'לא נתמך',
  com_nav_export_all_message_branches: 'ייצא את כל ענפי ההודעות',
  com_nav_export_recursive_or_sequential: 'רקורסיבי או רציף?',
  com_nav_export_recursive: 'רקורסיבי',
  com_nav_export_conversation: 'ייצא שיחה',
  com_nav_export: 'ייצא',
  com_nav_shared_links: 'קישורים משותפים',
  com_nav_shared_links_manage: 'ניהול',
  com_nav_shared_links_empty: 'אין לך קישורים משותפים.',
  com_nav_shared_links_name: 'שם',
  com_nav_shared_links_date_shared: 'תאריך שיתוף',
  com_nav_theme: 'נושא',
  com_nav_theme_system: 'מערכת',
  com_nav_theme_dark: 'כהה',
  com_nav_theme_light: 'אור',
  com_nav_font_size: 'גודל גופן',
  com_nav_user_name_display: 'הצג שם משתמש בהודעות',
  com_nav_save_drafts: 'שמיר את האפצה באותו מחשב',
  com_nav_clear_all_chats: 'נקה את כל השיחות',
  com_nav_confirm_clear: 'אשר נקה',
  com_nav_close_sidebar: 'סגור סרגל צד',
  com_nav_open_sidebar: 'פתח סרגל צד',
  com_nav_send_message: 'שלח הודעה',
  com_nav_log_out: 'צא',
  com_nav_user: 'USER',
  com_nav_archived_chats: 'שיחות מארכיון',
  com_nav_archived_chats_manage: 'ניהול',
  com_nav_archived_chats_empty: 'אין שיחות מארכיון.',
  com_nav_archive_all_chats: 'ארכין כל השיחות',
  com_nav_archive_all: 'ארכין כל',
  com_nav_archive_name: 'שם',
  com_nav_archive_created_at: 'תאריך יצרן',
  com_nav_clear_conversation: 'נקה שיחות',
  com_nav_clear_conversation_confirm_message:
    'אתה בטוח שאתה רוצה לנקות את כל השיחות? זה בלתי הפיך.',
  com_nav_help_faq: 'עזרה ושאלות נפוצות',
  com_nav_settings: 'הגדרות',
  com_nav_search_placeholder: 'חפש הודעות',
  com_nav_info_bookmarks_rebuild:
    'אם ספירת הסימניות שגויה, נא לבנות מחדש את המידע של הסמניות. הספירה תחושב מחדש והנתונים ישוחזרו למצב הנכון.',
  com_nav_setting_general: 'כללי',
  com_nav_setting_beta: 'תכונות ביטא',
  com_nav_setting_data: 'בקרות נתונים',
  com_nav_setting_account: 'חשבון',
  com_nav_lang_english: 'English',
  com_nav_lang_chinese: '中文',
  com_nav_lang_german: 'Deutsch',
  com_nav_lang_spanish: 'Español',
  com_nav_lang_french: 'Français ',
  com_nav_lang_italian: 'Italiano',
  com_nav_lang_polish: 'Polski',
  com_nav_lang_brazilian_portuguese: 'Português Brasileiro',
  com_nav_lang_russian: 'Русский',
  com_nav_lang_japanese: '日本語',
  com_nav_lang_swedish: 'Svenska',
  com_nav_lang_korean: '한국어',
  com_nav_lang_vietnamese: 'Tiếng Việt',
  com_nav_lang_traditionalchinese: '繁體中文',
  com_nav_lang_arabic: 'العربية',
  com_nav_lang_turkish: 'Türkçe',
  com_nav_lang_dutch: 'Nederlands',
  com_nav_lang_indonesia: 'Indonesia',
  com_nav_lang_hebrew: 'עברית',
  com_nav_lang_finnish: 'Suomi',
};
